import { Injectable } from "@angular/core";

import { css } from "@codemirror/lang-css";
import { LanguageDescription, LanguageSupport } from "@codemirror/language";


@Injectable()
export class CssEditorLanguageService {

    public getLanguageDescription(): LanguageDescription {
        const language: LanguageSupport = css();

        return LanguageDescription.of({ name: language.language.name, support: language })
    }
}